module.exports = __webpack_public_path__ + "img/temp-banner-forecast.f76b74bf.jpg";